import { useTranslation } from "react-i18next";
import { setLang, SUPPORTED_LANGS } from "@/i18n";
import type { Lang } from "@/lib/types";

const LABELS: Record<Lang, string> = {
  fr: "FR",
  ar: "عربي",
  darija: "Darija",
};

export function LangSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language as Lang;

  return (
    <div className="flex items-center gap-1" role="group" aria-label="Sélection de langue">
      {SUPPORTED_LANGS.map((lang) => {
        const active = current === lang;
        return (
          <button
            key={lang}
            type="button"
            onClick={() => setLang(lang)}
            className={
              "rounded-pill px-3 py-1.5 text-caption font-medium transition-colors " +
              (active ? "bg-ink text-paper" : "text-muted hover:bg-ink/5 hover:text-ink")
            }
            aria-pressed={active}
          >
            {LABELS[lang]}
          </button>
        );
      })}
    </div>
  );
}
